(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-coroutines-core.js', './ktor-ktor-utils.js', './ktor-ktor-io.js', './kotlinx-io-kotlinx-io-core.js', './kotlinx-atomicfu.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-coroutines-core.js'), require('./ktor-ktor-utils.js'), require('./ktor-ktor-io.js'), require('./kotlinx-io-kotlinx-io-core.js'), require('./kotlinx-atomicfu.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-websockets'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'ktor-ktor-websockets'.");
    }
    if (typeof globalThis['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-websockets'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'ktor-ktor-websockets'.");
    }
    if (typeof globalThis['ktor-ktor-utils'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-websockets'. Its dependency 'ktor-ktor-utils' was not found. Please, check whether 'ktor-ktor-utils' is loaded prior to 'ktor-ktor-websockets'.");
    }
    if (typeof globalThis['ktor-ktor-io'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-websockets'. Its dependency 'ktor-ktor-io' was not found. Please, check whether 'ktor-ktor-io' is loaded prior to 'ktor-ktor-websockets'.");
    }
    if (typeof globalThis['kotlinx-io-kotlinx-io-core'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-websockets'. Its dependency 'kotlinx-io-kotlinx-io-core' was not found. Please, check whether 'kotlinx-io-kotlinx-io-core' is loaded prior to 'ktor-ktor-websockets'.");
    }
    if (typeof globalThis['kotlinx-atomicfu'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-websockets'. Its dependency 'kotlinx-atomicfu' was not found. Please, check whether 'kotlinx-atomicfu' is loaded prior to 'ktor-ktor-websockets'.");
    }
    globalThis['ktor-ktor-websockets'] = factory(typeof globalThis['ktor-ktor-websockets'] === 'undefined' ? {} : globalThis['ktor-ktor-websockets'], globalThis['kotlin-kotlin-stdlib'], globalThis['kotlinx-coroutines-core'], globalThis['ktor-ktor-utils'], globalThis['ktor-ktor-io'], globalThis['kotlinx-io-kotlinx-io-core'], globalThis['kotlinx-atomicfu']);
  }
}(function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_io_ktor_ktor_utils, kotlin_io_ktor_ktor_io, kotlin_org_jetbrains_kotlinx_kotlinx_io_core, kotlin_org_jetbrains_kotlinx_atomicfu) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.b8;
  var mapCapacity = kotlin_kotlin.$_$.ua;
  var coerceAtLeast = kotlin_kotlin.$_$.wh;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.i4;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var enumEntries = kotlin_kotlin.$_$.ae;
  var objectCreate = kotlin_kotlin.$_$.dh;
  var Enum = kotlin_kotlin.$_$.en;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var VOID = kotlin_kotlin.$_$.d;
  var toString = kotlin_kotlin.$_$.hh;
  var getStringHashCode = kotlin_kotlin.$_$.ag;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var Long = kotlin_kotlin.$_$.kn;
  var isInterface = kotlin_kotlin.$_$.rg;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var Dispatchers_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.h;
  var launch = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q3;
  var CoroutineStart_UNDISPATCHED_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.o;
  var compare = kotlin_kotlin.$_$.je;
  var ChannelResult = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.g1;
  var _ChannelResult___get_isSuccess__impl__odq1z9 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.c;
  var CoroutineImpl = kotlin_kotlin.$_$.xd;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.y2;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.gd;
  var initMetadataForLambda = kotlin_kotlin.$_$.hg;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var get_isTraceEnabled = kotlin_io_ktor_ktor_utils.$_$.h;
  var BytePacketBuilder = kotlin_io_ktor_ktor_io.$_$.v;
  var writeFully = kotlin_io_ktor_ktor_io.$_$.e1;
  var ensureNotNull = kotlin_kotlin.$_$.lo;
  var build = kotlin_io_ktor_ktor_io.$_$.w;
  var readByteArray = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.k;
  var cancelConsumed = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.n1;
  var ClosedSendChannelException = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.j1;
  var CancellationException_init_$Create$ = kotlin_kotlin.$_$.s4;
  var ChannelIOException = kotlin_io_ktor_ktor_utils.$_$.b;
  var CancellationException = kotlin_kotlin.$_$.fd;
  var ClosedReceiveChannelException = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.i1;
  var IOException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.c;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.eg;
  var toString_0 = kotlin_kotlin.$_$.hp;
  var get_size = kotlin_io_ktor_ktor_io.$_$.b1;
  var fromInt = kotlin_kotlin.$_$.pe;
  var atomic$ref$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.d;
  var CompletableDeferred = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.s2;
  var Job = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.c3;
  var Key_instance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.j;
  var CoroutineName = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.w2;
  var Factory_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.d;
  var atomic$boolean$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.b;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.a4;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var joinToString = kotlin_kotlin.$_$.aa;
  var KtorSimpleLogger = kotlin_io_ktor_ktor_utils.$_$.g;
  var Buffer = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.f;
  var readText = kotlin_io_ktor_ktor_io.$_$.z;
  var DisposableHandle = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.b3;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var Exception = kotlin_kotlin.$_$.gn;
  var Exception_init_$Init$ = kotlin_kotlin.$_$.e5;
  var captureStack = kotlin_kotlin.$_$.gf;
  var defineProp = kotlin_kotlin.$_$.pf;
  var CopyableThrowable = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.u2;
  var compareTo = kotlin_kotlin.$_$.nf;
  var Channel = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.h1;
  var Charsets_getInstance = kotlin_io_ktor_ktor_io.$_$.b;
  var toByteArray = kotlin_io_ktor_ktor_io.$_$.d1;
  var decodeToString = kotlin_kotlin.$_$.qj;
  var getTimeMillis = kotlin_io_ktor_ktor_utils.$_$.e;
  var Random = kotlin_kotlin.$_$.qh;
  var withTimeoutOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.b1;
  var toHexString = kotlin_kotlin.$_$.wl;
  var ClosedByteChannelException = kotlin_io_ktor_ktor_io.$_$.n1;
  var BufferOverflow_SUSPEND_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.m;
  var throwUninitializedPropertyAccessException = kotlin_kotlin.$_$.ce;
  var BufferOverflow_DROP_OLDEST_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.l;
  var _ChannelResult___get_isClosed__impl__mg7kuu = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.b;
  var close$default = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.f1;
  var cancel$default = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.e1;
  var ReceiveChannel = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.l1;
  var SendChannel = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.m1;
  var RuntimeException = kotlin_kotlin.$_$.rn;
  var RuntimeException_init_$Init$ = kotlin_kotlin.$_$.i6;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.z3;
  var split = kotlin_kotlin.$_$.cl;
  var first = kotlin_kotlin.$_$.o9;
  var isCharSequence = kotlin_kotlin.$_$.ng;
  var trim = kotlin_kotlin.$_$.mm;
  var drop = kotlin_kotlin.$_$.b9;
  var writeText = kotlin_io_ktor_ktor_io.$_$.f1;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.uo;
  //endregion
  //region block: pre-declaration
  initMetadataForCompanion(Companion);
  initMetadataForClass(Codes, 'Codes', VOID, Enum);
  initMetadataForClass(CloseReason, 'CloseReason');
  function send(frame, $completion) {
    return this.dtf().r1s(frame, $completion);
  }
  initMetadataForInterface(WebSocketSession, 'WebSocketSession', VOID, VOID, [CoroutineScope], [1, 0]);
  initMetadataForInterface(DefaultWebSocketSession, 'DefaultWebSocketSession', VOID, VOID, [WebSocketSession], [1, 0]);
  initMetadataForCompanion(Companion_0);
  initMetadataForLambda(DefaultWebSocketSessionImpl$start$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(DefaultWebSocketSessionImpl$runIncomingProcessor$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(DefaultWebSocketSessionImpl$runOrCancelPinger$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($outgoingProcessorLoopCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($sendCloseSequenceCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($checkMaxFrameSizeCOROUTINE$, CoroutineImpl);
  initMetadataForClass(DefaultWebSocketSessionImpl, 'DefaultWebSocketSessionImpl', VOID, VOID, [DefaultWebSocketSession, WebSocketSession], [1, 0, 2]);
  initMetadataForObject(NonDisposableHandle, 'NonDisposableHandle', VOID, VOID, [DisposableHandle]);
  initMetadataForClass(FrameTooBigException, 'FrameTooBigException', VOID, Exception, [CopyableThrowable]);
  initMetadataForCompanion(Companion_1);
  initMetadataForClass(FrameType, 'FrameType', VOID, Enum);
  initMetadataForLambda(ponger$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(pinger$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(pinger$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(pinger$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCompanion(Companion_2);
  initMetadataForClass(WebSocketChannelsConfig, 'WebSocketChannelsConfig', WebSocketChannelsConfig);
  initMetadataForCompanion(Companion_3);
  initMetadataForClass(ChannelConfig, 'ChannelConfig');
  initMetadataForClass(ChannelOverflow, 'ChannelOverflow', VOID, Enum);
  initMetadataForCompanion(Companion_4);
  initMetadataForClass(BoundedChannel, 'BoundedChannel', VOID, VOID, [ReceiveChannel, SendChannel], [1, 0]);
  initMetadataForClass(ChannelOverflowException, 'ChannelOverflowException', VOID, RuntimeException);
  initMetadataForInterface(WebSocketExtension, 'WebSocketExtension');
  initMetadataForClass(WebSocketExtensionsConfig, 'WebSocketExtensionsConfig', WebSocketExtensionsConfig);
  initMetadataForClass(WebSocketExtensionHeader, 'WebSocketExtensionHeader');
  initMetadataForCoroutine($closeCOROUTINE$, CoroutineImpl);
  initMetadataForClass(Frame, 'Frame');
  initMetadataForClass(Binary, 'Binary', VOID, Frame);
  initMetadataForClass(Text, 'Text', VOID, Frame);
  initMetadataForClass(Close, 'Close', Close_init_$Create$_0, Frame);
  initMetadataForClass(Ping, 'Ping', VOID, Frame);
  initMetadataForClass(Pong, 'Pong', VOID, Frame);
  initMetadataForCompanion(Companion_5);
  //endregion
  var Codes_NORMAL_instance;
  var Codes_GOING_AWAY_instance;
  var Codes_PROTOCOL_ERROR_instance;
  var Codes_CANNOT_ACCEPT_instance;
  var Codes_CLOSED_ABNORMALLY_instance;
  var Codes_NOT_CONSISTENT_instance;
  var Codes_VIOLATED_POLICY_instance;
  var Codes_TOO_BIG_instance;
  var Codes_NO_EXTENSION_instance;
  var Codes_INTERNAL_ERROR_instance;
  var Codes_SERVICE_RESTART_instance;
  var Codes_TRY_AGAIN_LATER_instance;
  function Companion() {
    Companion_instance = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = get_entries();
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap_init_$Create$(capacity);
    var _iterator__ex2g4s = this_0.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var tmp$ret$2 = element.ste_1;
      destination.z2(tmp$ret$2, element);
    }
    tmp.tte_1 = destination;
    this.ute_1 = Codes_INTERNAL_ERROR_getInstance();
  }
  protoOf(Companion).vte = function (code) {
    return this.tte_1.w2(code);
  };
  var Companion_instance;
  function Companion_getInstance() {
    Codes_initEntries();
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function values() {
    return [Codes_NORMAL_getInstance(), Codes_GOING_AWAY_getInstance(), Codes_PROTOCOL_ERROR_getInstance(), Codes_CANNOT_ACCEPT_getInstance(), Codes_CLOSED_ABNORMALLY_getInstance(), Codes_NOT_CONSISTENT_getInstance(), Codes_VIOLATED_POLICY_getInstance(), Codes_TOO_BIG_getInstance(), Codes_NO_EXTENSION_getInstance(), Codes_INTERNAL_ERROR_getInstance(), Codes_SERVICE_RESTART_getInstance(), Codes_TRY_AGAIN_LATER_getInstance()];
  }
  function get_entries() {
    if ($ENTRIES == null)
      $ENTRIES = enumEntries(values());
    return $ENTRIES;
  }
  var Codes_entriesInitialized;
  function Codes_initEntries() {
    if (Codes_entriesInitialized)
      return Unit_instance;
    Codes_entriesInitialized = true;
    Codes_NORMAL_instance = new Codes('NORMAL', 0, 1000);
    Codes_GOING_AWAY_instance = new Codes('GOING_AWAY', 1, 1001);
    Codes_PROTOCOL_ERROR_instance = new Codes('PROTOCOL_ERROR', 2, 1002);
    Codes_CANNOT_ACCEPT_instance = new Codes('CANNOT_ACCEPT', 3, 1003);
    Codes_CLOSED_ABNORMALLY_instance = new Codes('CLOSED_ABNORMALLY', 4, 1006);
    Codes_NOT_CONSISTENT_instance = new Codes('NOT_CONSISTENT', 5, 1007);
    Codes_VIOLATED_POLICY_instance = new Codes('VIOLATED_POLICY', 6, 1008);
    Codes_TOO_BIG_instance = new Codes('TOO_BIG', 7, 1009);
    Codes_NO_EXTENSION_instance = new Codes('NO_EXTENSION', 8, 1010);
    Codes_INTERNAL_ERROR_instance = new Codes('INTERNAL_ERROR', 9, 1011);
    Codes_SERVICE_RESTART_instance = new Codes('SERVICE_RESTART', 10, 1012);
    Codes_TRY_AGAIN_LATER_instance = new Codes('TRY_AGAIN_LATER', 11, 1013);
    Companion_getInstance();
  }
  var $ENTRIES;
  function CloseReason_init_$Init$(code, message, $this) {
    CloseReason.call($this, code.ste_1, message);
    return $this;
  }
  function CloseReason_init_$Create$(code, message) {
    return CloseReason_init_$Init$(code, message, objectCreate(protoOf(CloseReason)));
  }
  function Codes(name, ordinal, code) {
    Enum.call(this, name, ordinal);
    this.ste_1 = code;
  }
  function Codes_NORMAL_getInstance() {
    Codes_initEntries();
    return Codes_NORMAL_instance;
  }
  function Codes_GOING_AWAY_getInstance() {
    Codes_initEntries();
    return Codes_GOING_AWAY_instance;
  }
  function Codes_PROTOCOL_ERROR_getInstance() {
    Codes_initEntries();
    return Codes_PROTOCOL_ERROR_instance;
  }
  function Codes_CANNOT_ACCEPT_getInstance() {
    Codes_initEntries();
    return Codes_CANNOT_ACCEPT_instance;
  }
  function Codes_CLOSED_ABNORMALLY_getInstance() {
    Codes_initEntries();
    return Codes_CLOSED_ABNORMALLY_instance;
  }
  function Codes_NOT_CONSISTENT_getInstance() {
    Codes_initEntries();
    return Codes_NOT_CONSISTENT_instance;
  }
  function Codes_VIOLATED_POLICY_getInstance() {
    Codes_initEntries();
    return Codes_VIOLATED_POLICY_instance;
  }
  function Codes_TOO_BIG_getInstance() {
    Codes_initEntries();
    return Codes_TOO_BIG_instance;
  }
  function Codes_NO_EXTENSION_getInstance() {
    Codes_initEntries();
    return Codes_NO_EXTENSION_instance;
  }
  function Codes_INTERNAL_ERROR_getInstance() {
    Codes_initEntries();
    return Codes_INTERNAL_ERROR_instance;
  }
  function Codes_SERVICE_RESTART_getInstance() {
    Codes_initEntries();
    return Codes_SERVICE_RESTART_instance;
  }
  function Codes_TRY_AGAIN_LATER_getInstance() {
    Codes_initEntries();
    return Codes_TRY_AGAIN_LATER_instance;
  }
  function CloseReason(code, message) {
    this.wte_1 = code;
    this.xte_1 = message;
  }
  protoOf(CloseReason).yte = function () {
    return Companion_getInstance().vte(this.wte_1);
  };
  protoOf(CloseReason).toString = function () {
    var tmp0_elvis_lhs = this.yte();
    return 'CloseReason(reason=' + toString(tmp0_elvis_lhs == null ? this.wte_1 : tmp0_elvis_lhs) + ', message=' + this.xte_1 + ')';
  };
  protoOf(CloseReason).hashCode = function () {
    var result = this.wte_1;
    result = imul(result, 31) + getStringHashCode(this.xte_1) | 0;
    return result;
  };
  protoOf(CloseReason).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CloseReason))
      return false;
    if (!(this.wte_1 === other.wte_1))
      return false;
    if (!(this.xte_1 === other.xte_1))
      return false;
    return true;
  };
  function get_LOGGER() {
    _init_properties_DefaultWebSocketSession_kt__469s0y();
    return LOGGER;
  }
  var LOGGER;
  function get_IncomingProcessorCoroutineName() {
    _init_properties_DefaultWebSocketSession_kt__469s0y();
    return IncomingProcessorCoroutineName;
  }
  var IncomingProcessorCoroutineName;
  function get_OutgoingProcessorCoroutineName() {
    _init_properties_DefaultWebSocketSession_kt__469s0y();
    return OutgoingProcessorCoroutineName;
  }
  var OutgoingProcessorCoroutineName;
  function get_NORMAL_CLOSE() {
    _init_properties_DefaultWebSocketSession_kt__469s0y();
    return NORMAL_CLOSE;
  }
  var NORMAL_CLOSE;
  var OUTGOING_CHANNEL_CONFIG;
  function DefaultWebSocketSession() {
  }
  function DefaultWebSocketSession_0(session, pingIntervalMillis, timeoutMillis, channelsConfig) {
    pingIntervalMillis = pingIntervalMillis === VOID ? new Long(0, 0) : pingIntervalMillis;
    timeoutMillis = timeoutMillis === VOID ? new Long(15000, 0) : timeoutMillis;
    channelsConfig = channelsConfig === VOID ? Companion_getInstance_2().ftf_1 : channelsConfig;
    _init_properties_DefaultWebSocketSession_kt__469s0y();
    // Inline function 'kotlin.require' call
    if (!!isInterface(session, DefaultWebSocketSession)) {
      var message = 'Cannot wrap other DefaultWebSocketSession';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return new DefaultWebSocketSessionImpl(session, pingIntervalMillis, timeoutMillis, channelsConfig.gtf_1, channelsConfig.htf_1);
  }
  function runIncomingProcessor($this, ponger) {
    var tmp = get_IncomingProcessorCoroutineName().xj(Dispatchers_getInstance().j1h_1);
    return launch($this, tmp, VOID, DefaultWebSocketSessionImpl$runIncomingProcessor$slambda_0($this, ponger, null));
  }
  function runOutgoingProcessor($this) {
    var tmp = get_OutgoingProcessorCoroutineName().xj(Dispatchers_getInstance().j1h_1);
    var tmp_0 = CoroutineStart_UNDISPATCHED_getInstance();
    return launch($this, tmp, tmp_0, DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda_0($this, null));
  }
  function outgoingProcessorLoop($this, $completion) {
    var tmp = new $outgoingProcessorLoopCOROUTINE$($this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function sendCloseSequence($this, reason, exception, $completion) {
    exception = exception === VOID ? null : exception;
    var tmp = new $sendCloseSequenceCOROUTINE$($this, reason, exception, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function tryClose($this) {
    return $this.mtg_1.atomicfu$compareAndSet(false, true);
  }
  function runOrCancelPinger($this) {
    var interval = $this.ptg_1;
    var tmp;
    if ($this.mtg_1.kotlinx$atomicfu$value) {
      tmp = null;
    } else if (compare(interval, new Long(0, 0)) > 0) {
      var tmp_0 = $this.ftg_1.dtf();
      var tmp_1 = $this.qtg_1;
      tmp = pinger($this, tmp_0, interval, tmp_1, DefaultWebSocketSessionImpl$runOrCancelPinger$slambda_0($this, null));
    } else {
      tmp = null;
    }
    var newPinger = tmp;
    var tmp0_safe_receiver = $this.gtg_1.atomicfu$getAndSet(newPinger);
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.b1t();
    var tmp2_safe_receiver = newPinger == null ? null : new ChannelResult(newPinger.s1s(Companion_getInstance_0().stg_1));
    if (tmp2_safe_receiver == null)
      null;
    else
      _ChannelResult___get_isSuccess__impl__odq1z9(tmp2_safe_receiver.s1p_1);
    if ($this.mtg_1.kotlinx$atomicfu$value && !(newPinger == null)) {
      runOrCancelPinger($this);
    }
  }
  function checkMaxFrameSize($this, packet, frame, $completion) {
    var tmp = new $checkMaxFrameSizeCOROUTINE$($this, packet, frame, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function processIncomingExtensions($this, frame) {
    // Inline function 'kotlin.collections.fold' call
    var accumulator = frame;
    var _iterator__ex2g4s = $this.fth().t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var current = accumulator;
      accumulator = element.gth(current);
    }
    return accumulator;
  }
  function processOutgoingExtensions($this, frame) {
    // Inline function 'kotlin.collections.fold' call
    var accumulator = frame;
    var _iterator__ex2g4s = $this.fth().t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var current = accumulator;
      accumulator = element.hth(current);
    }
    return accumulator;
  }
  function Companion_0() {
    Companion_instance_0 = this;
    this.stg_1 = new Pong(new Int8Array(0), NonDisposableHandle_instance);
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function DefaultWebSocketSessionImpl$start$slambda($incomingJob, $outgoingJob, this$0, resultContinuation) {
    this.qth_1 = $incomingJob;
    this.rth_1 = $outgoingJob;
    this.sth_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DefaultWebSocketSessionImpl$start$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DefaultWebSocketSessionImpl$start$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DefaultWebSocketSessionImpl$start$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = this.qth_1.x1a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            suspendResult = this.rth_1.x1a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.sth_1.itg_1.b1b();
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(DefaultWebSocketSessionImpl$start$slambda).q24 = function ($this$launch, completion) {
    var i = new DefaultWebSocketSessionImpl$start$slambda(this.qth_1, this.rth_1, this.sth_1, completion);
    i.tth_1 = $this$launch;
    return i;
  };
  function DefaultWebSocketSessionImpl$start$slambda_0($incomingJob, $outgoingJob, this$0, resultContinuation) {
    var i = new DefaultWebSocketSessionImpl$start$slambda($incomingJob, $outgoingJob, this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function DefaultWebSocketSessionImpl$runIncomingProcessor$slambda(this$0, $ponger, resultContinuation) {
    this.cti_1 = this$0;
    this.dti_1 = $ponger;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DefaultWebSocketSessionImpl$runIncomingProcessor$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DefaultWebSocketSessionImpl$runIncomingProcessor$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DefaultWebSocketSessionImpl$runIncomingProcessor$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 39;
            this.oti_1 = null;
            this.hti_1 = null;
            this.gti_1 = false;
            this.iti_1 = Unit_instance;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.o9_1 = 33;
            this.o9_1 = 32;
            this.sti_1 = this.cti_1.ftg_1.ctf();
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.lti_1 = this.sti_1;
            this.kti_1 = null;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.n9_1 = 5;
            continue $sm;
          case 5:
            this.n9_1 = 6;
            continue $sm;
          case 6:
            this.o9_1 = 29;
            this.o9_1 = 28;
            this.rti_1 = this.lti_1.t();
            this.n9_1 = 7;
            continue $sm;
          case 7:
            this.n9_1 = 8;
            suspendResult = this.rti_1.d1q(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            if (!suspendResult) {
              this.n9_1 = 26;
              continue $sm;
            }

            var e = this.rti_1.v();
            this.qti_1 = e;
            this.n9_1 = 9;
            continue $sm;
          case 9:
            this.pti_1 = this.qti_1;
            var this_0 = get_LOGGER();
            if (get_isTraceEnabled(this_0)) {
              this_0.hsu('WebSocketSession(' + toString(this.eti_1) + ') receiving frame ' + this.pti_1.toString());
            }

            var tmp0_subject = this.pti_1;
            if (tmp0_subject instanceof Close) {
              if (!this.cti_1.dtf().f1q()) {
                this.n9_1 = 18;
                var tmp_0 = this.cti_1.dtf();
                var tmp1_elvis_lhs = readReason(this.pti_1);
                suspendResult = tmp_0.r1s(Close_init_$Create$(tmp1_elvis_lhs == null ? get_NORMAL_CLOSE() : tmp1_elvis_lhs), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.n9_1 = 19;
                continue $sm;
              }
            } else {
              if (tmp0_subject instanceof Pong) {
                var tmp2_safe_receiver = this.cti_1.gtg_1.kotlinx$atomicfu$value;
                if (tmp2_safe_receiver == null) {
                  this.nti_1 = null;
                  this.n9_1 = 17;
                  continue $sm;
                } else {
                  this.n9_1 = 16;
                  suspendResult = tmp2_safe_receiver.r1s(this.pti_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                }
              } else {
                if (tmp0_subject instanceof Ping) {
                  this.n9_1 = 15;
                  suspendResult = this.dti_1.r1s(this.pti_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  this.n9_1 = 10;
                  suspendResult = checkMaxFrameSize(this.cti_1, this.hti_1, this.pti_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                }
              }
            }

          case 10:
            if (!this.pti_1.tti_1) {
              if (this.oti_1 == null) {
                this.oti_1 = this.pti_1;
              }
              if (this.hti_1 == null) {
                this.hti_1 = BytePacketBuilder();
              }
              writeFully(this.hti_1, this.pti_1.vti_1);
              this.n9_1 = 21;
              continue $sm;
            } else {
              this.n9_1 = 11;
              continue $sm;
            }

          case 11:
            if (this.oti_1 == null) {
              this.n9_1 = 14;
              suspendResult = this.cti_1.ktg_1.r1s(processIncomingExtensions(this.cti_1, this.pti_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 12;
              continue $sm;
            }

          case 12:
            writeFully(ensureNotNull(this.hti_1), this.pti_1.vti_1);
            var defragmented = Companion_getInstance_5().btj(true, this.oti_1.uti_1, readByteArray(build(this.hti_1)), this.oti_1.xti_1, this.oti_1.yti_1, this.oti_1.zti_1);
            this.oti_1 = null;
            this.n9_1 = 13;
            suspendResult = this.cti_1.ktg_1.r1s(processIncomingExtensions(this.cti_1, defragmented), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 13:
            var tmp_1 = this;
            tmp_1.mti_1 = Unit_instance;
            this.n9_1 = 20;
            continue $sm;
          case 14:
            this.n9_1 = 21;
            continue $sm;
          case 15:
            var tmp_2 = this;
            tmp_2.mti_1 = Unit_instance;
            this.n9_1 = 20;
            continue $sm;
          case 16:
            var tmp_3 = this;
            tmp_3.nti_1 = Unit_instance;
            this.n9_1 = 17;
            continue $sm;
          case 17:
            this.mti_1 = this.nti_1;
            this.n9_1 = 20;
            continue $sm;
          case 18:
            this.n9_1 = 19;
            continue $sm;
          case 19:
            this.gti_1 = true;
            this.n9_1 = 22;
            var tmp_4 = this;
            continue $sm;
          case 20:
            if (false) {
              this.n9_1 = 9;
              continue $sm;
            }

            this.n9_1 = 21;
            continue $sm;
          case 21:
            this.n9_1 = 7;
            continue $sm;
          case 22:
            this.o9_1 = 32;
            cancelConsumed(this.lti_1, this.kti_1);
            this.o9_1 = 39;
            this.n9_1 = 23;
            continue $sm;
          case 23:
            this.o9_1 = 39;
            this.dti_1.b1t();
            var tmp0_safe_receiver = this.hti_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              tmp0_safe_receiver.j4();
            }

            this.cti_1.ktg_1.b1t();
            if (!this.gti_1) {
              this.n9_1 = 24;
              suspendResult = close(this.cti_1, CloseReason_init_$Create$(Codes_CLOSED_ABNORMALLY_getInstance(), 'Connection was closed without close frame'), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 25;
              continue $sm;
            }

          case 24:
            this.n9_1 = 25;
            continue $sm;
          case 25:
            var tmp_5 = this;
            return Unit_instance;
          case 26:
            this.n9_1 = 27;
            var tmp_6 = this;
            continue $sm;
          case 27:
            this.o9_1 = 32;
            cancelConsumed(this.lti_1, this.kti_1);
            this.n9_1 = 31;
            continue $sm;
          case 28:
            this.o9_1 = 29;
            var tmp_7 = this.q9_1;
            if (tmp_7 instanceof Error) {
              var e_0 = this.q9_1;
              var tmp_8 = this;
              this.kti_1 = e_0;
              throw e_0;
            } else {
              throw this.q9_1;
            }

          case 29:
            this.o9_1 = 32;
            var t = this.q9_1;
            cancelConsumed(this.lti_1, this.kti_1);
            throw t;
          case 30:
            this.o9_1 = 32;
            cancelConsumed(this.lti_1, this.kti_1);
            if (false) {
              this.n9_1 = 3;
              continue $sm;
            }

            this.n9_1 = 31;
            continue $sm;
          case 31:
            this.iti_1 = Unit_instance;
            this.o9_1 = 39;
            this.n9_1 = 36;
            continue $sm;
          case 32:
            this.o9_1 = 33;
            var tmp_9 = this.q9_1;
            if (tmp_9 instanceof ClosedSendChannelException) {
              var _unused_var__etf5q3 = this.q9_1;
              var tmp_10 = this;
              tmp_10.iti_1 = Unit_instance;
              this.o9_1 = 39;
              this.n9_1 = 36;
              continue $sm;
            } else {
              var tmp_11 = this.q9_1;
              if (tmp_11 instanceof Error) {
                var cause = this.q9_1;
                var tmp_12 = this;
                this.dti_1.b1t();
                tmp_12.iti_1 = this.cti_1.ktg_1.z1s(cause);
                this.o9_1 = 39;
                this.n9_1 = 36;
                continue $sm;
              } else {
                throw this.q9_1;
              }
            }

          case 33:
            this.o9_1 = 39;
            this.jti_1 = this.q9_1;
            this.dti_1.b1t();
            var tmp0_safe_receiver_0 = this.hti_1;
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              tmp0_safe_receiver_0.j4();
            }

            this.cti_1.ktg_1.b1t();
            if (!this.gti_1) {
              this.n9_1 = 34;
              suspendResult = close(this.cti_1, CloseReason_init_$Create$(Codes_CLOSED_ABNORMALLY_getInstance(), 'Connection was closed without close frame'), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 35;
              continue $sm;
            }

          case 34:
            this.n9_1 = 35;
            continue $sm;
          case 35:
            throw this.jti_1;
          case 36:
            this.fti_1 = this.iti_1;
            this.o9_1 = 39;
            this.dti_1.b1t();
            var tmp0_safe_receiver_1 = this.hti_1;
            if (tmp0_safe_receiver_1 == null)
              null;
            else {
              tmp0_safe_receiver_1.j4();
            }

            this.cti_1.ktg_1.b1t();
            if (!this.gti_1) {
              this.n9_1 = 37;
              suspendResult = close(this.cti_1, CloseReason_init_$Create$(Codes_CLOSED_ABNORMALLY_getInstance(), 'Connection was closed without close frame'), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 38;
              continue $sm;
            }

          case 37:
            this.n9_1 = 38;
            continue $sm;
          case 38:
            return Unit_instance;
          case 39:
            throw this.q9_1;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.o9_1 === 39) {
          throw e_1;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(DefaultWebSocketSessionImpl$runIncomingProcessor$slambda).q24 = function ($this$launch, completion) {
    var i = new DefaultWebSocketSessionImpl$runIncomingProcessor$slambda(this.cti_1, this.dti_1, completion);
    i.eti_1 = $this$launch;
    return i;
  };
  function DefaultWebSocketSessionImpl$runIncomingProcessor$slambda_0(this$0, $ponger, resultContinuation) {
    var i = new DefaultWebSocketSessionImpl$runIncomingProcessor$slambda(this$0, $ponger, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda(this$0, resultContinuation) {
    this.ktj_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 13;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.o9_1 = 9;
            this.o9_1 = 4;
            this.n9_1 = 3;
            suspendResult = outgoingProcessorLoop(this.ktj_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.o9_1 = 13;
            this.n9_1 = 11;
            continue $sm;
          case 4:
            this.o9_1 = 9;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof ClosedSendChannelException) {
              var _unused_var__etf5q3 = this.q9_1;
              this.o9_1 = 13;
              this.n9_1 = 11;
              continue $sm;
            } else {
              var tmp_1 = this.q9_1;
              if (tmp_1 instanceof ClosedReceiveChannelException) {
                var _unused_var__etf5q3_0 = this.q9_1;
                this.o9_1 = 13;
                this.n9_1 = 11;
                continue $sm;
              } else {
                var tmp_2 = this.q9_1;
                if (tmp_2 instanceof CancellationException) {
                  var _unused_var__etf5q3_1 = this.q9_1;
                  this.n9_1 = 5;
                  suspendResult = sendCloseSequence(this.ktj_1, CloseReason_init_$Create$(Codes_NORMAL_getInstance(), ''), VOID, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  var tmp_3 = this.q9_1;
                  if (tmp_3 instanceof ChannelIOException) {
                    var _unused_var__etf5q3_2 = this.q9_1;
                    this.o9_1 = 13;
                    this.n9_1 = 11;
                    continue $sm;
                  } else {
                    var tmp_4 = this.q9_1;
                    if (tmp_4 instanceof Error) {
                      var cause = this.q9_1;
                      this.ktj_1.ltg_1.a1b(CancellationException_init_$Create$('Failed to send frame', cause));
                      this.n9_1 = 6;
                      suspendResult = closeExceptionally(this.ktj_1.ftg_1, cause, this);
                      if (suspendResult === get_COROUTINE_SUSPENDED()) {
                        return suspendResult;
                      }
                      continue $sm;
                    } else {
                      throw this.q9_1;
                    }
                  }
                }
              }
            }

          case 5:
            this.o9_1 = 13;
            this.n9_1 = 11;
            continue $sm;
          case 6:
            this.o9_1 = 13;
            this.n9_1 = 7;
            continue $sm;
          case 7:
            this.o9_1 = 13;
            this.ktj_1.ltg_1.d1t();
            this.n9_1 = 8;
            suspendResult = close(this.ktj_1.ftg_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            return Unit_instance;
          case 9:
            this.o9_1 = 13;
            this.mtj_1 = this.q9_1;
            this.ktj_1.ltg_1.d1t();
            this.n9_1 = 10;
            suspendResult = close(this.ktj_1.ftg_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 10:
            throw this.mtj_1;
          case 11:
            this.o9_1 = 13;
            this.ktj_1.ltg_1.d1t();
            this.n9_1 = 12;
            suspendResult = close(this.ktj_1.ftg_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 12:
            return Unit_instance;
          case 13:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 13) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda).q24 = function ($this$launch, completion) {
    var i = new DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda(this.ktj_1, completion);
    i.ltj_1 = $this$launch;
    return i;
  };
  function DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda_0(this$0, resultContinuation) {
    var i = new DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function DefaultWebSocketSessionImpl$runOrCancelPinger$slambda(this$0, resultContinuation) {
    this.vtj_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DefaultWebSocketSessionImpl$runOrCancelPinger$slambda).xtj = function (it, $completion) {
    var tmp = this.ytj(it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DefaultWebSocketSessionImpl$runOrCancelPinger$slambda).ja = function (p1, $completion) {
    return this.xtj(p1 instanceof CloseReason ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DefaultWebSocketSessionImpl$runOrCancelPinger$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = sendCloseSequence(this.vtj_1, this.wtj_1, IOException_init_$Create$('Ping timeout'), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(DefaultWebSocketSessionImpl$runOrCancelPinger$slambda).ytj = function (it, completion) {
    var i = new DefaultWebSocketSessionImpl$runOrCancelPinger$slambda(this.vtj_1, completion);
    i.wtj_1 = it;
    return i;
  };
  function DefaultWebSocketSessionImpl$runOrCancelPinger$slambda_0(this$0, resultContinuation) {
    var i = new DefaultWebSocketSessionImpl$runOrCancelPinger$slambda(this$0, resultContinuation);
    return constructCallableReference(function (it, $completion) {
      return i.xtj(it, $completion);
    }, 1);
  }
  function $outgoingProcessorLoopCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.qtf_1 = _this__u8e3s4;
  }
  protoOf($outgoingProcessorLoopCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 7;
            this.stf_1 = this.qtf_1.ltg_1.t();
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.n9_1 = 2;
            suspendResult = this.stf_1.d1q(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            if (!suspendResult) {
              this.n9_1 = 6;
              continue $sm;
            }

            var frame = this.stf_1.v();
            var this_0 = get_LOGGER();
            if (get_isTraceEnabled(this_0)) {
              this_0.hsu('Sending ' + frame.toString() + ' from session ' + toString(this.qtf_1));
            }

            if (frame instanceof Close) {
              this.n9_1 = 3;
              suspendResult = sendCloseSequence(this.qtf_1, readReason(frame), VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_0;
              if (frame instanceof Text) {
                tmp_0 = true;
              } else {
                tmp_0 = frame instanceof Binary;
              }
              if (tmp_0) {
                this.rtf_1 = processOutgoingExtensions(this.qtf_1, frame);
                this.n9_1 = 4;
                continue $sm;
              } else {
                this.rtf_1 = frame;
                this.n9_1 = 4;
                continue $sm;
              }
            }

          case 3:
            this.n9_1 = 6;
            var tmp_1 = this;
            continue $sm;
          case 4:
            var processedFrame = this.rtf_1;
            this.n9_1 = 5;
            suspendResult = this.qtf_1.ftg_1.dtf().r1s(processedFrame, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.n9_1 = 1;
            continue $sm;
          case 6:
            return Unit_instance;
          case 7:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 7) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $sendCloseSequenceCOROUTINE$(_this__u8e3s4, reason, exception, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.btg_1 = _this__u8e3s4;
    this.ctg_1 = reason;
    this.dtg_1 = exception;
  }
  protoOf($sendCloseSequenceCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            if (!tryClose(this.btg_1))
              return Unit_instance;
            var this_0 = get_LOGGER();
            if (get_isTraceEnabled(this_0)) {
              this_0.hsu('Sending Close Sequence for session ' + toString(this.btg_1) + ' with reason ' + toString_0(this.ctg_1) + ' and exception ' + toString_0(this.dtg_1));
            }

            this.btg_1.itg_1.w1g();
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.ctg_1;
            tmp_0.etg_1 = tmp0_elvis_lhs == null ? CloseReason_init_$Create$(Codes_NORMAL_getInstance(), '') : tmp0_elvis_lhs;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 5;
            runOrCancelPinger(this.btg_1);
            if (!(this.etg_1.wte_1 === Codes_CLOSED_ABNORMALLY_getInstance().ste_1)) {
              this.n9_1 = 2;
              suspendResult = this.btg_1.ftg_1.dtf().r1s(Close_init_$Create$(this.etg_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.o9_1 = 6;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.o9_1 = 6;
            this.btg_1.htg_1.u1g(this.etg_1);
            if (!(this.dtg_1 == null)) {
              this.btg_1.ltg_1.z1s(this.dtg_1);
              this.btg_1.ktg_1.z1s(this.dtg_1);
            }

            return Unit_instance;
          case 5:
            this.o9_1 = 6;
            var t = this.q9_1;
            this.btg_1.htg_1.u1g(this.etg_1);
            if (!(this.dtg_1 == null)) {
              this.btg_1.ltg_1.z1s(this.dtg_1);
              this.btg_1.ktg_1.z1s(this.dtg_1);
            }

            throw t;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 6) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $checkMaxFrameSizeCOROUTINE$(_this__u8e3s4, packet, frame, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.bth_1 = _this__u8e3s4;
    this.cth_1 = packet;
    this.dth_1 = frame;
  }
  protoOf($checkMaxFrameSizeCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp_0 = this;
            var tmp_1 = this.dth_1.vti_1.length;
            var tmp0_safe_receiver = this.cth_1;
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_size(tmp0_safe_receiver);
            tmp_0.eth_1 = tmp_1 + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
            if (compare(fromInt(this.eth_1), this.bth_1.btf()) > 0) {
              var tmp2_safe_receiver = this.cth_1;
              if (tmp2_safe_receiver == null)
                null;
              else {
                tmp2_safe_receiver.j4();
              }
              this.n9_1 = 2;
              suspendResult = close(this.bth_1, CloseReason_init_$Create$(Codes_TOO_BIG_getInstance(), 'Frame is too big: ' + this.eth_1 + '. Max size is ' + this.bth_1.btf().toString()), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 1;
              continue $sm;
            }

          case 1:
            return Unit_instance;
          case 2:
            throw new FrameTooBigException(fromInt(this.eth_1));
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function DefaultWebSocketSessionImpl(raw, pingIntervalMillis, timeoutMillis, incomingFramesConfig, outgoingFramesConfig) {
    Companion_getInstance_0();
    this.ftg_1 = raw;
    this.gtg_1 = atomic$ref$1(null);
    this.htg_1 = CompletableDeferred();
    this.itg_1 = Job();
    this.jtg_1 = this.ftg_1.q19().vj(Key_instance).xj(this.itg_1).xj(new CoroutineName('ws-default'));
    this.ktg_1 = from(Factory_getInstance(), incomingFramesConfig);
    this.ltg_1 = from(Factory_getInstance(), outgoingFramesConfig);
    this.mtg_1 = atomic$boolean$1(false);
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.ntg_1 = ArrayList_init_$Create$();
    this.otg_1 = atomic$boolean$1(false);
    this.ptg_1 = pingIntervalMillis;
    this.qtg_1 = timeoutMillis;
    this.rtg_1 = this.htg_1;
  }
  protoOf(DefaultWebSocketSessionImpl).q19 = function () {
    return this.jtg_1;
  };
  protoOf(DefaultWebSocketSessionImpl).ctf = function () {
    return this.ktg_1;
  };
  protoOf(DefaultWebSocketSessionImpl).dtf = function () {
    return this.ltg_1;
  };
  protoOf(DefaultWebSocketSessionImpl).fth = function () {
    return this.ntg_1;
  };
  protoOf(DefaultWebSocketSessionImpl).atf = function (value) {
    this.ftg_1.atf(value);
  };
  protoOf(DefaultWebSocketSessionImpl).btf = function () {
    return this.ftg_1.btf();
  };
  protoOf(DefaultWebSocketSessionImpl).zte = function (negotiatedExtensions) {
    if (!this.otg_1.atomicfu$compareAndSet(false, true)) {
      // Inline function 'kotlin.error' call
      var message = 'WebSocket session ' + toString(this) + ' is already started.';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    // Inline function 'io.ktor.util.logging.trace' call
    var this_0 = get_LOGGER();
    if (get_isTraceEnabled(this_0)) {
      var tmp$ret$2 = 'Starting default WebSocketSession(' + toString(this) + ') ' + ('with negotiated extensions: ' + joinToString(negotiatedExtensions));
      this_0.hsu(tmp$ret$2);
    }
    this.ntg_1.o1(negotiatedExtensions);
    runOrCancelPinger(this);
    var incomingJob = runIncomingProcessor(this, ponger(this, this.dtf()));
    var outgoingJob = runOutgoingProcessor(this);
    launch(this, VOID, VOID, DefaultWebSocketSessionImpl$start$slambda_0(incomingJob, outgoingJob, this, null));
  };
  protoOf(DefaultWebSocketSessionImpl).ksc = function ($completion) {
    return this.ftg_1.ksc($completion);
  };
  var properties_initialized_DefaultWebSocketSession_kt_6cjlhc;
  function _init_properties_DefaultWebSocketSession_kt__469s0y() {
    if (!properties_initialized_DefaultWebSocketSession_kt_6cjlhc) {
      properties_initialized_DefaultWebSocketSession_kt_6cjlhc = true;
      LOGGER = KtorSimpleLogger('io.ktor.websocket.WebSocket');
      IncomingProcessorCoroutineName = new CoroutineName('ws-incoming-processor');
      OutgoingProcessorCoroutineName = new CoroutineName('ws-outgoing-processor');
      NORMAL_CLOSE = CloseReason_init_$Create$(Codes_NORMAL_getInstance(), 'OK');
      var tmp0_safe_receiver = get_OUTGOING_CHANNEL_CAPACITY();
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp = new ChannelConfig(tmp0_safe_receiver, ChannelOverflow_SUSPEND_getInstance());
      }
      OUTGOING_CHANNEL_CONFIG = tmp;
    }
  }
  function readReason(_this__u8e3s4) {
    if (_this__u8e3s4.vti_1.length < 2) {
      return null;
    }
    // Inline function 'io.ktor.utils.io.core.buildPacket' call
    var builder = new Buffer();
    writeFully(builder, _this__u8e3s4.vti_1);
    var packet = builder;
    var code = packet.zs7();
    var message = readText(packet);
    return new CloseReason(code, message);
  }
  function NonDisposableHandle() {
  }
  protoOf(NonDisposableHandle).s1d = function () {
    return Unit_instance;
  };
  protoOf(NonDisposableHandle).toString = function () {
    return 'NonDisposableHandle';
  };
  protoOf(NonDisposableHandle).hashCode = function () {
    return 207988788;
  };
  protoOf(NonDisposableHandle).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NonDisposableHandle))
      return false;
    return true;
  };
  var NonDisposableHandle_instance;
  function NonDisposableHandle_getInstance() {
    return NonDisposableHandle_instance;
  }
  function FrameTooBigException(frameSize, cause) {
    cause = cause === VOID ? null : cause;
    Exception_init_$Init$(cause, this);
    captureStack(this, FrameTooBigException);
    this.ztj_1 = frameSize;
    delete this.message;
  }
  protoOf(FrameTooBigException).e = function () {
    var sizeSuffix = compare(this.ztj_1, new Long(0, 0)) >= 0 ? ': ' + this.ztj_1.toString() : '';
    return 'Frame is too big' + sizeSuffix;
  };
  protoOf(FrameTooBigException).n1h = function () {
    return new FrameTooBigException(this.ztj_1, this);
  };
  var FrameType_TEXT_instance;
  var FrameType_BINARY_instance;
  var FrameType_CLOSE_instance;
  var FrameType_PING_instance;
  var FrameType_PONG_instance;
  function Companion_1() {
    Companion_instance_1 = this;
    var tmp = this;
    var tmp0 = get_entries_0();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.maxByOrNull' call
      var iterator = tmp0.t();
      if (!iterator.u()) {
        tmp$ret$0 = null;
        break $l$block_0;
      }
      var maxElem = iterator.v();
      if (!iterator.u()) {
        tmp$ret$0 = maxElem;
        break $l$block_0;
      }
      var maxValue = maxElem.dtk_1;
      do {
        var e = iterator.v();
        var v = e.dtk_1;
        if (compareTo(maxValue, v) < 0) {
          maxElem = e;
          maxValue = v;
        }
      }
       while (iterator.u());
      tmp$ret$0 = maxElem;
    }
    tmp.etk_1 = ensureNotNull(tmp$ret$0).dtk_1;
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = this.etk_1 + 1 | 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_3 = Array(tmp_2);
    while (tmp_1 < tmp_2) {
      var tmp_4 = tmp_1;
      var tmp0_0 = get_entries_0();
      var tmp$ret$5;
      $l$block_2: {
        // Inline function 'kotlin.collections.singleOrNull' call
        var single = null;
        var found = false;
        var _iterator__ex2g4s = tmp0_0.t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          if (element.dtk_1 === tmp_4) {
            if (found) {
              tmp$ret$5 = null;
              break $l$block_2;
            }
            single = element;
            found = true;
          }
        }
        if (!found) {
          tmp$ret$5 = null;
          break $l$block_2;
        }
        tmp$ret$5 = single;
      }
      tmp_3[tmp_4] = tmp$ret$5;
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0.ftk_1 = tmp_3;
  }
  var Companion_instance_1;
  function Companion_getInstance_1() {
    FrameType_initEntries();
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function values_0() {
    return [FrameType_TEXT_getInstance(), FrameType_BINARY_getInstance(), FrameType_CLOSE_getInstance(), FrameType_PING_getInstance(), FrameType_PONG_getInstance()];
  }
  function get_entries_0() {
    if ($ENTRIES_0 == null)
      $ENTRIES_0 = enumEntries(values_0());
    return $ENTRIES_0;
  }
  var FrameType_entriesInitialized;
  function FrameType_initEntries() {
    if (FrameType_entriesInitialized)
      return Unit_instance;
    FrameType_entriesInitialized = true;
    FrameType_TEXT_instance = new FrameType('TEXT', 0, false, 1);
    FrameType_BINARY_instance = new FrameType('BINARY', 1, false, 2);
    FrameType_CLOSE_instance = new FrameType('CLOSE', 2, true, 8);
    FrameType_PING_instance = new FrameType('PING', 3, true, 9);
    FrameType_PONG_instance = new FrameType('PONG', 4, true, 10);
    Companion_getInstance_1();
  }
  var $ENTRIES_0;
  function FrameType(name, ordinal, controlFrame, opcode) {
    Enum.call(this, name, ordinal);
    this.ctk_1 = controlFrame;
    this.dtk_1 = opcode;
  }
  function FrameType_TEXT_getInstance() {
    FrameType_initEntries();
    return FrameType_TEXT_instance;
  }
  function FrameType_BINARY_getInstance() {
    FrameType_initEntries();
    return FrameType_BINARY_instance;
  }
  function FrameType_CLOSE_getInstance() {
    FrameType_initEntries();
    return FrameType_CLOSE_instance;
  }
  function FrameType_PING_getInstance() {
    FrameType_initEntries();
    return FrameType_PING_instance;
  }
  function FrameType_PONG_getInstance() {
    FrameType_initEntries();
    return FrameType_PONG_instance;
  }
  function get_PongerCoroutineName() {
    _init_properties_PingPong_kt__9aqxey();
    return PongerCoroutineName;
  }
  var PongerCoroutineName;
  function get_PingerCoroutineName() {
    _init_properties_PingPong_kt__9aqxey();
    return PingerCoroutineName;
  }
  var PingerCoroutineName;
  function ponger(_this__u8e3s4, outgoing) {
    _init_properties_PingPong_kt__9aqxey();
    var channel = Channel(5);
    var tmp = get_PongerCoroutineName();
    launch(_this__u8e3s4, tmp, VOID, ponger$slambda_0(channel, outgoing, null));
    return channel;
  }
  function pinger(_this__u8e3s4, outgoing, periodMillis, timeoutMillis, onTimeout) {
    _init_properties_PingPong_kt__9aqxey();
    var actorJob = Job();
    var channel = Channel(2147483647);
    var tmp = actorJob.xj(get_PingerCoroutineName());
    launch(_this__u8e3s4, tmp, VOID, pinger$slambda_0(periodMillis, timeoutMillis, onTimeout, channel, outgoing, null));
    var tmp_0 = ensureNotNull(_this__u8e3s4.q19().aa(Key_instance));
    tmp_0.t1a(pinger$lambda(actorJob));
    return channel;
  }
  function ponger$slambda($channel, $outgoing, resultContinuation) {
    this.otk_1 = $channel;
    this.ptk_1 = $outgoing;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ponger$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ponger$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ponger$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 14;
            this.o9_1 = 13;
            this.utk_1 = this.otk_1;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.stk_1 = this.utk_1;
            this.rtk_1 = null;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.o9_1 = 10;
            this.o9_1 = 9;
            this.ttk_1 = this.stk_1.t();
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.n9_1 = 5;
            suspendResult = this.ttk_1.d1q(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            if (!suspendResult) {
              this.n9_1 = 7;
              continue $sm;
            }

            var e = this.ttk_1.v();
            get_LOGGER().hsu('Received ping message, sending pong message');
            this.n9_1 = 6;
            suspendResult = this.ptk_1.r1s(new Pong(e.vti_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.n9_1 = 4;
            continue $sm;
          case 7:
            this.n9_1 = 8;
            var tmp_0 = this;
            continue $sm;
          case 8:
            this.o9_1 = 13;
            cancelConsumed(this.stk_1, this.rtk_1);
            this.n9_1 = 12;
            continue $sm;
          case 9:
            this.o9_1 = 10;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Error) {
              var e_0 = this.q9_1;
              var tmp_2 = this;
              this.rtk_1 = e_0;
              throw e_0;
            } else {
              throw this.q9_1;
            }

          case 10:
            this.o9_1 = 13;
            var t = this.q9_1;
            cancelConsumed(this.stk_1, this.rtk_1);
            throw t;
          case 11:
            this.o9_1 = 13;
            cancelConsumed(this.stk_1, this.rtk_1);
            if (false) {
              this.n9_1 = 1;
              continue $sm;
            }

            this.n9_1 = 12;
            continue $sm;
          case 12:
            this.o9_1 = 14;
            this.n9_1 = 15;
            continue $sm;
          case 13:
            this.o9_1 = 14;
            var tmp_3 = this.q9_1;
            if (tmp_3 instanceof ClosedSendChannelException) {
              var _unused_var__etf5q3 = this.q9_1;
              this.n9_1 = 15;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 14:
            throw this.q9_1;
          case 15:
            this.o9_1 = 14;
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.o9_1 === 14) {
          throw e_1;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(ponger$slambda).q24 = function ($this$launch, completion) {
    var i = new ponger$slambda(this.otk_1, this.ptk_1, completion);
    i.qtk_1 = $this$launch;
    return i;
  };
  function ponger$slambda_0($channel, $outgoing, resultContinuation) {
    var i = new ponger$slambda($channel, $outgoing, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function pinger$slambda$slambda($channel, resultContinuation) {
    this.dtl_1 = $channel;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(pinger$slambda$slambda).p24 = function ($this$withTimeoutOrNull, $completion) {
    var tmp = this.q24($this$withTimeoutOrNull, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(pinger$slambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(pinger$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!true) {
              this.n9_1 = 4;
              continue $sm;
            }

            this.n9_1 = 2;
            suspendResult = this.dtl_1.u1s(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.n9_1 = 1;
            continue $sm;
          case 3:
            throw this.q9_1;
          case 4:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(pinger$slambda$slambda).q24 = function ($this$withTimeoutOrNull, completion) {
    var i = new pinger$slambda$slambda(this.dtl_1, completion);
    i.etl_1 = $this$withTimeoutOrNull;
    return i;
  };
  function pinger$slambda$slambda_0($channel, resultContinuation) {
    var i = new pinger$slambda$slambda($channel, resultContinuation);
    return constructCallableReference(function ($this$withTimeoutOrNull, $completion) {
      return i.p24($this$withTimeoutOrNull, $completion);
    }, 1);
  }
  function pinger$slambda$slambda_1($outgoing, $pingMessage, $channel, resultContinuation) {
    this.ntl_1 = $outgoing;
    this.otl_1 = $pingMessage;
    this.ptl_1 = $channel;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(pinger$slambda$slambda_1).p24 = function ($this$withTimeoutOrNull, $completion) {
    var tmp = this.q24($this$withTimeoutOrNull, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(pinger$slambda$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(pinger$slambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            get_LOGGER().hsu('WebSocket Pinger: sending ping frame');
            this.n9_1 = 1;
            suspendResult = this.ntl_1.r1s(new Ping(toByteArray(this.otl_1, Charsets_getInstance().qsm_1)), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            if (!true) {
              this.n9_1 = 5;
              continue $sm;
            }

            this.n9_1 = 3;
            suspendResult = this.ptl_1.u1s(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.rtl_1 = suspendResult;
            if (decodeToString(this.rtl_1.vti_1, 0, 0 + this.rtl_1.vti_1.length | 0) === this.otl_1) {
              get_LOGGER().hsu('WebSocket Pinger: received valid pong frame ' + this.rtl_1.toString());
              this.n9_1 = 5;
              continue $sm;
            } else {
              this.n9_1 = 4;
              continue $sm;
            }

          case 4:
            get_LOGGER().hsu('WebSocket Pinger: received invalid pong frame ' + this.rtl_1.toString() + ', continue waiting');
            this.n9_1 = 2;
            continue $sm;
          case 5:
            return Unit_instance;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 6) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(pinger$slambda$slambda_1).q24 = function ($this$withTimeoutOrNull, completion) {
    var i = new pinger$slambda$slambda_1(this.ntl_1, this.otl_1, this.ptl_1, completion);
    i.qtl_1 = $this$withTimeoutOrNull;
    return i;
  };
  function pinger$slambda$slambda_2($outgoing, $pingMessage, $channel, resultContinuation) {
    var i = new pinger$slambda$slambda_1($outgoing, $pingMessage, $channel, resultContinuation);
    return constructCallableReference(function ($this$withTimeoutOrNull, $completion) {
      return i.p24($this$withTimeoutOrNull, $completion);
    }, 1);
  }
  function pinger$slambda($periodMillis, $timeoutMillis, $onTimeout, $channel, $outgoing, resultContinuation) {
    this.atm_1 = $periodMillis;
    this.btm_1 = $timeoutMillis;
    this.ctm_1 = $onTimeout;
    this.dtm_1 = $channel;
    this.etm_1 = $outgoing;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(pinger$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(pinger$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(pinger$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 9;
            get_LOGGER().hsu('Starting WebSocket pinger coroutine with period ' + this.atm_1.toString() + ' ms and timeout ' + this.btm_1.toString() + ' ms');
            this.htm_1 = Random(getTimeMillis());
            this.gtm_1 = new Int8Array(32);
            this.o9_1 = 7;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!true) {
              this.n9_1 = 6;
              continue $sm;
            }

            this.n9_1 = 2;
            suspendResult = withTimeoutOrNull(this.atm_1, pinger$slambda$slambda_0(this.dtm_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.htm_1.tl(this.gtm_1);
            var pingMessage = '[ping ' + toHexString(this.gtm_1) + ' ping]';
            this.n9_1 = 3;
            suspendResult = withTimeoutOrNull(this.btm_1, pinger$slambda$slambda_2(this.etm_1, pingMessage, this.dtm_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var rc = suspendResult;
            if (rc == null) {
              get_LOGGER().hsu('WebSocket pinger has timed out');
              this.n9_1 = 5;
              suspendResult = this.ctm_1(CloseReason_init_$Create$(Codes_INTERNAL_ERROR_getInstance(), 'Ping timeout'), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 4;
              continue $sm;
            }

          case 4:
            this.n9_1 = 1;
            continue $sm;
          case 5:
            this.n9_1 = 6;
            continue $sm;
          case 6:
            this.o9_1 = 9;
            this.n9_1 = 8;
            continue $sm;
          case 7:
            this.o9_1 = 9;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof CancellationException) {
              var ignore = this.q9_1;
              this.n9_1 = 8;
              continue $sm;
            } else {
              var tmp_1 = this.q9_1;
              if (tmp_1 instanceof ClosedReceiveChannelException) {
                var ignore_0 = this.q9_1;
                this.n9_1 = 8;
                continue $sm;
              } else {
                var tmp_2 = this.q9_1;
                if (tmp_2 instanceof ClosedSendChannelException) {
                  var ignore_1 = this.q9_1;
                  this.n9_1 = 8;
                  continue $sm;
                } else {
                  var tmp_3 = this.q9_1;
                  if (tmp_3 instanceof ClosedByteChannelException) {
                    var ignore_2 = this.q9_1;
                    this.n9_1 = 8;
                    continue $sm;
                  } else {
                    throw this.q9_1;
                  }
                }
              }
            }

          case 8:
            this.o9_1 = 9;
            return Unit_instance;
          case 9:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 9) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(pinger$slambda).q24 = function ($this$launch, completion) {
    var i = new pinger$slambda(this.atm_1, this.btm_1, this.ctm_1, this.dtm_1, this.etm_1, completion);
    i.ftm_1 = $this$launch;
    return i;
  };
  function pinger$slambda_0($periodMillis, $timeoutMillis, $onTimeout, $channel, $outgoing, resultContinuation) {
    var i = new pinger$slambda($periodMillis, $timeoutMillis, $onTimeout, $channel, $outgoing, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function pinger$lambda($actorJob) {
    return function (it) {
      $actorJob.b1b();
      return Unit_instance;
    };
  }
  var properties_initialized_PingPong_kt_fbfhmc;
  function _init_properties_PingPong_kt__9aqxey() {
    if (!properties_initialized_PingPong_kt_fbfhmc) {
      properties_initialized_PingPong_kt_fbfhmc = true;
      PongerCoroutineName = new CoroutineName('ws-ponger');
      PingerCoroutineName = new CoroutineName('ws-pinger');
    }
  }
  function Companion_2() {
    Companion_instance_2 = this;
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = new WebSocketChannelsConfig();
    this_0.gtf_1 = this_0.itm();
    this_0.htf_1 = this_0.itm();
    tmp.ftf_1 = this_0;
  }
  var Companion_instance_2;
  function Companion_getInstance_2() {
    if (Companion_instance_2 == null)
      new Companion_2();
    return Companion_instance_2;
  }
  function WebSocketChannelsConfig() {
    Companion_getInstance_2();
    this.gtf_1 = Companion_getInstance_3().jtm_1;
    this.htf_1 = Companion_getInstance_3().jtm_1;
  }
  protoOf(WebSocketChannelsConfig).itm = function () {
    return Companion_getInstance_3().jtm_1;
  };
  function from(_this__u8e3s4, config) {
    // Inline function 'kotlin.with' call
    var tmp;
    if (config.ktm_1 === 2147483647) {
      tmp = Channel(2147483647);
    } else if (config.ltm_1.equals(ChannelOverflow_SUSPEND_getInstance())) {
      tmp = Channel(config.ktm_1, BufferOverflow_SUSPEND_getInstance());
    } else if (config.ltm_1.equals(ChannelOverflow_CLOSE_getInstance())) {
      tmp = new BoundedChannel(config.ktm_1);
    } else {
      // Inline function 'kotlin.error' call
      var message = 'Unsupported channel config.';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    return tmp;
  }
  function Companion_3() {
    Companion_instance_3 = this;
    this.jtm_1 = new ChannelConfig(2147483647, ChannelOverflow_SUSPEND_getInstance());
  }
  var Companion_instance_3;
  function Companion_getInstance_3() {
    if (Companion_instance_3 == null)
      new Companion_3();
    return Companion_instance_3;
  }
  function ChannelConfig(capacity, onOverflow) {
    Companion_getInstance_3();
    this.ktm_1 = capacity;
    this.ltm_1 = onOverflow;
  }
  protoOf(ChannelConfig).mtm = function () {
    return this.ltm_1.equals(ChannelOverflow_SUSPEND_getInstance()) && !(this.ktm_1 === 2147483647);
  };
  var ChannelOverflow_SUSPEND_instance;
  var ChannelOverflow_CLOSE_instance;
  var ChannelOverflow_entriesInitialized;
  function ChannelOverflow_initEntries() {
    if (ChannelOverflow_entriesInitialized)
      return Unit_instance;
    ChannelOverflow_entriesInitialized = true;
    ChannelOverflow_SUSPEND_instance = new ChannelOverflow('SUSPEND', 0);
    ChannelOverflow_CLOSE_instance = new ChannelOverflow('CLOSE', 1);
  }
  function ChannelOverflow(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function BoundedChannel$Companion$createDelegate$lambda($channel) {
    return function (it) {
      var tmp;
      var tmp_0;
      if ($channel._v == null) {
        throwUninitializedPropertyAccessException('channel');
      } else {
        tmp_0 = $channel._v;
      }
      if (!tmp_0.f1q()) {
        var tmp_1;
        if ($channel._v == null) {
          throwUninitializedPropertyAccessException('channel');
        } else {
          tmp_1 = $channel._v;
        }
        tmp_1.z1s(new ChannelOverflowException('Channel overflowed'));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function Companion_4() {
  }
  protoOf(Companion_4).ntm = function (capacity) {
    var channel = {_v: null};
    var tmp = BufferOverflow_DROP_OLDEST_getInstance();
    // Inline function 'kotlin.also' call
    var this_0 = Channel(capacity, tmp, BoundedChannel$Companion$createDelegate$lambda(channel));
    channel._v = this_0;
    return this_0;
  };
  var Companion_instance_4;
  function Companion_getInstance_4() {
    return Companion_instance_4;
  }
  function BoundedChannel(capacity, delegate) {
    delegate = delegate === VOID ? Companion_instance_4.ntm(capacity) : delegate;
    this.otm_1 = delegate;
  }
  protoOf(BoundedChannel).ptm = function (element) {
    var result = this.otm_1.s1s(element);
    if (!_ChannelResult___get_isSuccess__impl__odq1z9(result) && !_ChannelResult___get_isClosed__impl__mg7kuu(result)) {
      this.z1s(new ChannelOverflowException('Channel overflowed'));
    }
    return result;
  };
  protoOf(BoundedChannel).s1s = function (element) {
    return this.ptm(element);
  };
  protoOf(BoundedChannel).qtm = function (element, $completion) {
    return this.otm_1.r1s(element, $completion);
  };
  protoOf(BoundedChannel).r1s = function (element, $completion) {
    return this.qtm(element, $completion);
  };
  protoOf(BoundedChannel).z1s = function (cause) {
    return this.otm_1.z1s(cause);
  };
  protoOf(BoundedChannel).f1q = function () {
    return this.otm_1.f1q();
  };
  protoOf(BoundedChannel).rtm = function ($completion) {
    return this.otm_1.u1s($completion);
  };
  protoOf(BoundedChannel).u1s = function ($completion) {
    return this.rtm($completion);
  };
  protoOf(BoundedChannel).stm = function ($completion) {
    var tmp = this.otm_1.v1s($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      return tmp;
    return tmp;
  };
  protoOf(BoundedChannel).v1s = function ($completion) {
    return this.stm($completion);
  };
  protoOf(BoundedChannel).ttm = function () {
    return this.otm_1.w1s();
  };
  protoOf(BoundedChannel).w1s = function () {
    return this.ttm();
  };
  protoOf(BoundedChannel).t = function () {
    return this.otm_1.t();
  };
  protoOf(BoundedChannel).a1b = function (cause) {
    this.otm_1.a1b(cause);
  };
  protoOf(BoundedChannel).x1s = function () {
    return this.otm_1.x1s();
  };
  function ChannelOverflowException(message) {
    RuntimeException_init_$Init$(message, this);
    captureStack(this, ChannelOverflowException);
  }
  function ChannelOverflow_SUSPEND_getInstance() {
    ChannelOverflow_initEntries();
    return ChannelOverflow_SUSPEND_instance;
  }
  function ChannelOverflow_CLOSE_getInstance() {
    ChannelOverflow_initEntries();
    return ChannelOverflow_CLOSE_instance;
  }
  function WebSocketExtension() {
  }
  function WebSocketExtensionsConfig() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.wtm_1 = ArrayList_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0.xtm_1 = [false, false, false];
  }
  protoOf(WebSocketExtensionsConfig).g3d = function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.wtm_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.t();
    while (_iterator__ex2g4s.u()) {
      var item = _iterator__ex2g4s.v();
      var tmp$ret$2 = item();
      destination.j1(tmp$ret$2);
    }
    return destination;
  };
  function parametersToString($this) {
    return $this.ztm_1.r() ? '' : '; ' + joinToString($this.ztm_1, ';');
  }
  function WebSocketExtensionHeader(name, parameters) {
    this.ytm_1 = name;
    this.ztm_1 = parameters;
  }
  protoOf(WebSocketExtensionHeader).toString = function () {
    return this.ytm_1 + ' ' + parametersToString(this);
  };
  function parseWebSocketExtensions(value) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = split(value, [',']);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.t();
    while (_iterator__ex2g4s.u()) {
      var item = _iterator__ex2g4s.v();
      var extension = split(item, [';']);
      // Inline function 'kotlin.text.trim' call
      var this_1 = first(extension);
      var name = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
      // Inline function 'kotlin.collections.map' call
      var this_2 = drop(extension, 1);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_2, 10));
      var _iterator__ex2g4s_0 = this_2.t();
      while (_iterator__ex2g4s_0.u()) {
        var item_0 = _iterator__ex2g4s_0.v();
        // Inline function 'kotlin.text.trim' call
        var tmp$ret$6 = toString(trim(isCharSequence(item_0) ? item_0 : THROW_CCE()));
        destination_0.j1(tmp$ret$6);
      }
      var parameters = destination_0;
      var tmp$ret$2 = new WebSocketExtensionHeader(name, parameters);
      destination.j1(tmp$ret$2);
    }
    return destination;
  }
  function WebSocketSession() {
  }
  function close(_this__u8e3s4, reason, $completion) {
    reason = reason === VOID ? CloseReason_init_$Create$(Codes_NORMAL_getInstance(), '') : reason;
    var tmp = new $closeCOROUTINE$(_this__u8e3s4, reason, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function closeExceptionally(_this__u8e3s4, cause, $completion) {
    var tmp;
    if (cause instanceof CancellationException) {
      tmp = CloseReason_init_$Create$(Codes_NORMAL_getInstance(), '');
    } else {
      tmp = CloseReason_init_$Create$(Codes_INTERNAL_ERROR_getInstance(), cause.toString());
    }
    var reason = tmp;
    return close(_this__u8e3s4, reason, $completion);
  }
  function $closeCOROUTINE$(_this__u8e3s4, reason, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.itn_1 = _this__u8e3s4;
    this.jtn_1 = reason;
  }
  protoOf($closeCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = this.itn_1.etf(Close_init_$Create$(this.jtn_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.n9_1 = 2;
            suspendResult = this.itn_1.ksc(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.o9_1 = 4;
            this.n9_1 = 5;
            continue $sm;
          case 3:
            this.o9_1 = 4;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Error) {
              var _unused_var__etf5q3 = this.q9_1;
              this.n9_1 = 5;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 4:
            throw this.q9_1;
          case 5:
            this.o9_1 = 4;
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function Binary_init_$Init$(fin, data, $this) {
    Binary.call($this, fin, data, false, false, false);
    return $this;
  }
  function Binary_init_$Create$(fin, data) {
    return Binary_init_$Init$(fin, data, objectCreate(protoOf(Binary)));
  }
  function Text_init_$Init$(fin, data, $this) {
    Text.call($this, fin, data, false, false, false);
    return $this;
  }
  function Text_init_$Init$_0(text, $this) {
    Text_init_$Init$(true, toByteArray(text), $this);
    return $this;
  }
  function Text_init_$Create$(text) {
    return Text_init_$Init$_0(text, objectCreate(protoOf(Text)));
  }
  function Close_init_$Init$(reason, $this) {
    // Inline function 'io.ktor.utils.io.core.buildPacket' call
    var builder = new Buffer();
    builder.es9(reason.wte_1);
    writeText(builder, reason.xte_1);
    Close_init_$Init$_0(builder, $this);
    return $this;
  }
  function Close_init_$Create$(reason) {
    return Close_init_$Init$(reason, objectCreate(protoOf(Close)));
  }
  function Close_init_$Init$_0(packet, $this) {
    Close.call($this, readByteArray(packet));
    return $this;
  }
  function Close_init_$Init$_1($this) {
    Close.call($this, Companion_getInstance_5().atj_1);
    return $this;
  }
  function Close_init_$Create$_0() {
    return Close_init_$Init$_1(objectCreate(protoOf(Close)));
  }
  function Binary(fin, data, rsv1, rsv2, rsv3) {
    rsv1 = rsv1 === VOID ? false : rsv1;
    rsv2 = rsv2 === VOID ? false : rsv2;
    rsv3 = rsv3 === VOID ? false : rsv3;
    Frame.call(this, fin, FrameType_BINARY_getInstance(), data, NonDisposableHandle_instance, rsv1, rsv2, rsv3);
  }
  function Text(fin, data, rsv1, rsv2, rsv3) {
    rsv1 = rsv1 === VOID ? false : rsv1;
    rsv2 = rsv2 === VOID ? false : rsv2;
    rsv3 = rsv3 === VOID ? false : rsv3;
    Frame.call(this, fin, FrameType_TEXT_getInstance(), data, NonDisposableHandle_instance, rsv1, rsv2, rsv3);
  }
  function Close(data) {
    Frame.call(this, true, FrameType_CLOSE_getInstance(), data, NonDisposableHandle_instance, false, false, false);
  }
  function Ping(data) {
    Frame.call(this, true, FrameType_PING_getInstance(), data, NonDisposableHandle_instance, false, false, false);
  }
  function Pong(data, disposableHandle) {
    disposableHandle = disposableHandle === VOID ? NonDisposableHandle_instance : disposableHandle;
    Frame.call(this, true, FrameType_PONG_getInstance(), data, disposableHandle, false, false, false);
  }
  function Companion_5() {
    Companion_instance_5 = this;
    this.atj_1 = new Int8Array(0);
  }
  protoOf(Companion_5).btj = function (fin, frameType, data, rsv1, rsv2, rsv3) {
    var tmp;
    switch (frameType.a1_1) {
      case 1:
        tmp = new Binary(fin, data, rsv1, rsv2, rsv3);
        break;
      case 0:
        tmp = new Text(fin, data, rsv1, rsv2, rsv3);
        break;
      case 2:
        tmp = new Close(data);
        break;
      case 3:
        tmp = new Ping(data);
        break;
      case 4:
        tmp = new Pong(data, NonDisposableHandle_instance);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  var Companion_instance_5;
  function Companion_getInstance_5() {
    if (Companion_instance_5 == null)
      new Companion_5();
    return Companion_instance_5;
  }
  function Frame(fin, frameType, data, disposableHandle, rsv1, rsv2, rsv3) {
    Companion_getInstance_5();
    disposableHandle = disposableHandle === VOID ? NonDisposableHandle_instance : disposableHandle;
    rsv1 = rsv1 === VOID ? false : rsv1;
    rsv2 = rsv2 === VOID ? false : rsv2;
    rsv3 = rsv3 === VOID ? false : rsv3;
    this.tti_1 = fin;
    this.uti_1 = frameType;
    this.vti_1 = data;
    this.wti_1 = disposableHandle;
    this.xti_1 = rsv1;
    this.yti_1 = rsv2;
    this.zti_1 = rsv3;
  }
  protoOf(Frame).toString = function () {
    return 'Frame ' + this.uti_1.toString() + ' (fin=' + this.tti_1 + ', buffer len = ' + this.vti_1.length + ')';
  };
  function get_OUTGOING_CHANNEL_CAPACITY() {
    return OUTGOING_CHANNEL_CAPACITY;
  }
  var OUTGOING_CHANNEL_CAPACITY;
  //region block: post-declaration
  protoOf(DefaultWebSocketSessionImpl).etf = send;
  defineProp(protoOf(FrameTooBigException), 'message', function () {
    return this.e();
  });
  protoOf(BoundedChannel).b1t = close$default;
  protoOf(BoundedChannel).d1t = cancel$default;
  //endregion
  //region block: init
  NonDisposableHandle_instance = new NonDisposableHandle();
  Companion_instance_4 = new Companion_4();
  OUTGOING_CHANNEL_CAPACITY = null;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Companion_getInstance;
  _.$_$.b = Companion_getInstance_2;
  _.$_$.c = Codes_CLOSED_ABNORMALLY_getInstance;
  _.$_$.d = Codes_NORMAL_getInstance;
  _.$_$.e = send;
  _.$_$.f = Binary_init_$Create$;
  _.$_$.g = Close_init_$Create$;
  _.$_$.h = Text_init_$Create$;
  _.$_$.i = CloseReason;
  _.$_$.j = DefaultWebSocketSession_0;
  _.$_$.k = DefaultWebSocketSession;
  _.$_$.l = WebSocketChannelsConfig;
  _.$_$.m = WebSocketExtensionsConfig;
  _.$_$.n = WebSocketExtension;
  _.$_$.o = WebSocketSession;
  _.$_$.p = from;
  _.$_$.q = parseWebSocketExtensions;
  //endregion
  return _;
}));

//# sourceMappingURL=ktor-ktor-websockets.js.map
